import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";

const getUser = {
    namespaced: true,
    state: {
        user: null,
    },
    mutations: {
        GET_USER_FAILURE(state, error) {
            console.error(error);
        },
        GET_USER_SUCCESS(state, response) {
            state.user = response.data.user || response.user || response.data || response;
        },
        RESET_USER_DATA(state) {
            state.user = null;
        },
    },
    actions: {
        fetchUser({ dispatch }) {
            return new Promise((resolve, reject) => {
                let promise = sendRequest("get", config.baseURLApi + "/users/profile");
                promise.then(function(result) {
                    if (result[0] === "success") {
                        dispatch("successGetUser", result[1]);
                        resolve(result[1]);
                    } else {
                        dispatch("failureGetUser", result[1]);
                        reject(result[1]);
                    }
                });
            });
        },
        successGetUser({ commit }, response) {
            commit("GET_USER_SUCCESS", response);
        },
        failureGetUser({ commit }, error) {
            commit("GET_USER_FAILURE", error);
        },
        resetUserData({ commit }) {
            commit("RESET_USER_DATA");
        },
    },
    getters: {
        currentUser: (state) => state.user,
    },
};

export default getUser;
